module.exports = __webpack_public_path__ + "img/SU1M7_new.0222de63.jpg";